import environment from '../../../.configs/app/environment.js'

/**
 * QA overlay / dev-tools visibility — opt-in flag plus allowed-app-env guard.
 *
 * Default: disabled. Requires `VITE_QA_OVERLAY_ENABLED=true` and an allowed
 * `VITE_APP_ENV` (qa1, qa2, qa3, development, workstation). Staging and
 * production are hard-blocked even if the flag is set.
 */

/** @type {readonly string[]} */
export const QA_DEV_TOOLS_ALLOWED_APP_ENVS = Object.freeze([
    'qa1',
    'qa2',
    'qa3',
    'development',
    'workstation',
])

/** @type {readonly string[]} */
export const QA_DEV_TOOLS_BLOCKED_APP_ENVS = Object.freeze([
    'production',
    'staging',
])

/**
 * @param {string|undefined|null} value
 * @returns {boolean}
 */
export const parseEnvBoolTrue = (value) => String(value ?? '').trim().toLowerCase() === 'true'

/**
 * @param {string|undefined|null} appEnv
 * @returns {boolean}
 */
export const isAllowedQaDevToolsAppEnv = (appEnvironment) => {
    if (!appEnvironment) {
        return false
    }
    if (QA_DEV_TOOLS_BLOCKED_APP_ENVS.includes(appEnvironment)) {
        return false
    }
    return QA_DEV_TOOLS_ALLOWED_APP_ENVS.includes(appEnvironment)
}

/**
 * @param {{ appEnv?: string|null, overlayEnabledFlag?: string|null }} options
 * @returns {boolean}
 */
export const isQaOverlayEnabled = ({
    appEnv,
    overlayEnabledFlag,
}) => {
    if (!parseEnvBoolTrue(overlayEnabledFlag)) {
        return false
    }
    return isAllowedQaDevToolsAppEnv(appEnv)
}

/** Whether QA overlay and related dev tooling should be active in this build. */
export const isQaOverlayEnabledForCurrentEnvironment = () => isQaOverlayEnabled({
    appEnv: process.env.VITE_APP_ENV || environment.app.env,
    overlayEnabledFlag: process.env.VITE_QA_OVERLAY_ENABLED ?? environment.qaOverlay.enabledFlag,
})

/**
 * @deprecated Prefer `isQaOverlayEnabledForCurrentEnvironment`.
 * @param {boolean} _isProduction
 * @returns {boolean}
 */
export const isQaDevToolsVisibleForProdFlag = (_isProduction) => isQaOverlayEnabledForCurrentEnvironment()
